import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, Text, TouchableWithoutFeedback } from 'react-native';
import { pt, isJDApp, isWX, isWQ, isIOS, isWeb, isAndroid, sendClickDataWithJsonParam, sendPv} from '../../../components/utiles';
import getCity from '../../../utils/lbs/index';
import { NAVIGATION_BAR_HEIGHT, SYS_BAR_HEIGHT } from '../../../utils/steep';
import { isSupportSceneId } from '../../../utils/lbs/lbsutils/utils';
import { manualRequestLocationPermission } from '../../../utils/lbs/lbsutils/getLocatioNew';
import { 
	getZufangCityList
 } from '../../../utils/api'
 import { JDScrollView, JDTouchable, JDText, JDImage, JDJumping, JDNativeSystem } from '@jdreact/jdreact-core-lib'
 import { cacheUtil, CacheKeyEnum } from '../../../utils/cacheManager';

 const img = {
    refresh: 'https://img10.360buyimg.com/imagetools/jfs/t1/176717/17/29373/2410/63148b18Ea5990c09/59911fdb86ff45d3.png',
    location: 'https://img14.360buyimg.com/imagetools/jfs/t1/181798/37/27727/3013/63148b18E87e1c745/1eb290aedb41bda7.png'
};
const Page_Id = 'OfficeBuilding_CityList'
const justLiulanqiHead = isWeb ? ((isJDApp || isWX || isWQ) ? 0 : pt(88)) : NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT

const CityTag = (props) => {
    return (
        <JDTouchable onPress={props.onSelect}>
            <View style={[styles.cityItem,props.showBtn && styles.btnBorder]}>
                {!!props.showLocationIcon && <JDImage source={{ uri: img.location }} style={styles.cityIcon} />}
                <JDText style={styles.cityName}>{props.title}</JDText>
            </View>
        </JDTouchable>

    );
};

const styles = StyleSheet.create({
    body: {
        width: pt(750),
        height: '100%',
        backgroundColor: '#ffffff',
    },
    barMeBox: {
        height: justLiulanqiHead,
        width: '100%'
    },
    content: {
        width: pt(750),
    },

    cityUl: {
        width: pt(750),
        backgroundColor: '#f6f6f6',
    },
    itemTitle: {
        width: pt(702),
        paddingHorizontal: pt(32)
    },
    cityUlBox: {
        width: pt(750),
        backgroundColor: '#ffffff',
        paddingHorizontal: pt(32)
    },
    itemTitleBox: {
        height:pt(56),
        justifyContent: 'center',
        borderBottomColor: '#f6f6f6'
    },
    historyItemBox: {
        height:pt(88),
        backgroundColor: '#ffffff',
        justifyContent: 'space-around',
        borderBottomWidth: pt(1),
        borderBottomColor: '#f6f6f6'
    },
    historyItemText: {
        fontSize: pt(28),
        color: '#2E2D2D'
    },
    activeIndexCity: {
        fontSize: pt(28),
        color: '#FA2C19'
    },
    posiTitleBox: {
        height:pt(88),
        justifyContent: 'center',
        backgroundColor: '#f6f6f6',
    },
    positionBox: {
        height:pt(90),
        backgroundColor: '#ffffff',
        paddingHorizontal: pt(32),
        alignItems: 'center',
		flexDirection: 'row',
        justifyContent: 'space-between'
    },
    positionTextBox: {

    },
    positionText: {
        fontSize: pt(30),
        color: '#1A1A1A'
    },
    positionBtn: {
        height:pt(58),
        backgroundColor: '#ffffff',
        paddingHorizontal: pt(12),
        borderRadius: pt(8),
        justifyContent: 'center',
        borderWidth: pt(1),
        borderColor: '#cccccc',
        marginRight: pt(32)
    },
    positionBtnText: {
        fontSize: pt(28),
        color: '#444444'
    },
    cityRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap'
    },
    getLocationBtn: {
        flexDirection: 'row',
        marginBottom: pt(24),
        marginLeft: pt(12)
    },
    getLocationText: {
        fontSize: pt(24),
        color: '#FA2C19'
    },
    getLocationIcon: {
        width: pt(26),
        height: pt(26)
    },
    cityIcon: {
        width: pt(28),
        height: pt(28),
        marginRight: pt(8)
    },
    cityName: {
        fontSize: pt(28),
        color: '#262626'
    },
    cityItem: {
        minWidth: pt(160),
        paddingHorizontal: pt(34),
        height: pt(88),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: pt(24),
    },
    btnBorder: {
        height:pt(58),
        marginVertical: pt(16),
        marginHorizontal: pt(32),
        paddingHorizontal: pt(20),
        borderRadius: pt(8),
        borderWidth: pt(1),
        borderColor: '#cccccc',
    }
});

export default class CityList extends React.PureComponent {
    static defaultProps = {
        changeCityClick: (e)=> {},
        changePositionInfo: (e)=> {},
		positionInfo:{},
        isPositionSucc: false,
        pageCityId: null
    }
    constructor(props) {
        super(props);
        this.state = {
            sortABC: [],
            canTurnOnLocation: false,
            myIsPositionSucc: this.props.isPositionSucc, // 是否定位成功
            myPositionCityInfo: this.props.positionInfo
        };
    }

    getUserLocation = () => {
        getCity().then(res => {
            const {isPositionSucc,cityId, cityName, open, lat, lon } = res
            if (!lat && !lon) {

            } else {
                this.setState({
                    myIsPositionSucc: isPositionSucc,
                    myPositionCityInfo: {
                        cityId,
                        cityName,
                        open,
                        lon,
                        lat
                    }
                })
                this.props.changePositionInfo(res)
            }
        });
    };

    getIsTurnOnLocationSupported = async() => {
        let flag = await isSupportSceneId();
        this.setState({
            canTurnOnLocation: flag
        })
    };

    componentDidMount() {
        sendPv({ pageId: Page_Id, pageParam: ''+ this.props.pageCityId });
        this.getIsTurnOnLocationSupported()
        this.getList()
    }

    getList = (e) => {
        let sortABC_ =cacheUtil.getCache(CacheKeyEnum.cityList_ABC) || [];
        let cityInfo_ =cacheUtil.getCache(CacheKeyEnum.cityList_Info) || {};
        if (isWeb && sortABC_ && sortABC_.length > 0) {
            this.setState({
                sortABC: sortABC_
            })
            this.cityInfo = cityInfo_
        } else {
            getZufangCityList({}).then(res => {
                if (res.code === 0 && res.citys && res.citys.length > 0) {
                    this.cityInfo = res.citys
                    const sortABC = this.cityInitialSort()
                    this.setState({
                        sortABC: sortABC
                    })
                    cacheUtil.setCache(CacheKeyEnum.cityList_ABC, sortABC);
                    cacheUtil.setCache(CacheKeyEnum.cityList_Info, res.citys);
                }
            }).catch(err => {
                
            })
        }
        
    }

    cityDatas = (words) => {
        let msg = this.cityInfo;
        words = words.toString().toLowerCase();
        words.toString().split("").map((word, num) => {
            msg = msg.filter((value, index) => {
                var str = value.firstChar.charAt(num).toLowerCase();
                return word == str;
            })
        })
        return msg;
    }

    cityInitialSort = () => {
        let cityWords = [];
        for(var i = 0; i < this.cityInfo.length; i++) {
            var str = this.cityInfo[i].firstChar;
            if (cityWords.indexOf(str) == -1) {
                cityWords.push(str);
                cityWords = cityWords.sort();
            }
        }
        return cityWords;
    }

    _changeCityClick = (item) => {
        sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_CityList_CitySelect',
            page_id: Page_Id,
			json_param: {
				cityid: item.id + ''
			},
		})
        this.props.changeCityClick({cityId:Number(item.id),cityName:item.name})
    }
    _positionCityClick = (item) => {
        if (item && item.cityId > 0) {
            sendClickDataWithJsonParam({
                event_id: 'OfficeBuilding_CityList_LocateCitySelect',
                page_id: Page_Id,
                json_param: {
                    cityid: item.cityId + ''
                },
            })
            this.props.changeCityClick({cityId:Number(item.cityId),cityName:item.cityName})
        }
    }

    turnOnPrivacySetting = async() => {
        const isSupport = await isSupportSceneId().catch(e => {
            console.log(e);
        });
        if (isSupport) {
            const that = this
            manualRequestLocationPermission().then(() => {
                that.getUserLocation();
            }).catch(() => {

            });
        } else {
            if (isIOS) {
                JDJumping.openUrl({ 'url': 'AppSettingUrl' }).catch();
            } else if (isAndroid) {
                JDNativeSystem.gpsSettings().then((data) => {
                    console.log(data);
                }, (error) => {
                    console.log(error);
                });
            }
        }
    };

    


    render() {
        const {
            customizeHotAndHistoryStyle,
            pageCityId
        } = this.props;
        const {
            canTurnOnLocation,
            myPositionCityInfo,
            myIsPositionSucc,
            sortABC
        } = this.state;
        return (
                <JDScrollView
                    showsVerticalScrollIndicator={false}
                    style={{}}
                    scrollToTop={true}
                    overScrollMode={'never'}
                    bounces={false}
                    scrollEventThrottle={16}
                    optimizedMode
                >
                    <View style={[styles.body, customizeHotAndHistoryStyle ? { ...customizeHotAndHistoryStyle } : '']}>
                        <View style={styles.barMeBox}></View>
                        <View style={styles.posiTitleBox}><Text style={styles.itemTitle}>当前定位城市</Text></View>

                        <View style={styles.cityRow}>
                            {!myIsPositionSucc
                                ? <CityTag showLocationIcon={false} title={canTurnOnLocation ? '开启定位' :'未获取到定位,请选择城市' } onSelect={canTurnOnLocation ? this.turnOnPrivacySetting : null} showBtn={canTurnOnLocation}/>
                                : <CityTag showLocationIcon={true}  title={myPositionCityInfo.cityName} onSelect={() => this._positionCityClick(myPositionCityInfo)} />}
                                {/* {(!myIsPositionSucc && !canTurnOnLocation) && <JDTouchable onPress={() => {
                                    this.getUserLocation();
                                }}>
                                    <View style={styles.positionBtn}>
                                        <JDText style={styles.positionBtnText}>重新定位</JDText>
                                    </View>
                                </JDTouchable>} */}
                        </View>

                        <View style={[styles.content]}>
                            {
                                sortABC.map((item, index) =>
                                <View style={styles.cityUl} key={index+ '__citybox'}>
                                        <View style={styles.itemTitleBox}><Text style={styles.itemTitle}>{item}</Text></View>
                                        <View style={styles.cityUlBox}>
                                            {
                                                this.cityDatas(item).map((iitem, iindex) => {
                                                    return (
                                                        <TouchableWithoutFeedback key={index+ '_' + iindex+'_city'} onPress={() => this._changeCityClick(iitem)}>
                                                            <View style={styles.historyItemBox}>
                                                                <Text style={pageCityId == iitem.id ? styles.activeIndexCity : styles.historyItemText}>{iitem.name}</Text>
                                                            </View>
                                                        </TouchableWithoutFeedback>
                                                    )
                                                })
                                            }
                                        </View>
                                </View>
                            )}
                        </View>
                    </View>
                </JDScrollView>
        );
    }
};


CityList.propTypes = {
    changeCityClick: PropTypes.func,
    cityInfo: PropTypes.object
};

CityList.defaultProps = {
    changeCityClick: () => {},
    cityInfo: {}
};
